(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mujeron-size-guide-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindDirectory = (root) => {
      if (!root || root.dataset.mjrGuideDirectoryBound === 'true') return;
      root.dataset.mjrGuideDirectoryBound = 'true';
      const input = root.querySelector('[data-mjr-guide-search]');
      const buttons = [...root.querySelectorAll('[data-mjr-guide-filter]')];
      const grid = root.querySelector('[data-mjr-guide-grid]');
      const originalCards = [...root.querySelectorAll('[data-mjr-guide-card]')];
      const brands = new Map();
      originalCards.forEach((card) => {
        const brand = card.dataset.guideBrand || 'Otras guías';
        if (!brands.has(brand)) brands.set(brand, []);
        brands.get(brand).push(card);
      });
      if (grid && !grid.querySelector('[data-mjr-guide-brand]')) {
        brands.forEach((brandCards, brand) => {
          const group = document.createElement('details');
          group.className = 'mjr-guide-brand';
          group.dataset.mjrGuideBrand = brand.toLowerCase();
          group.innerHTML = `
            <summary><strong>${brand}</strong><span class="mjr-icon" aria-hidden="true">+</span></summary>
            <div class="mjr-guide-brand__items"></div>
          `;
          const items = group.querySelector('.mjr-guide-brand__items');
          brandCards.forEach((card) => items.appendChild(card));
          grid.appendChild(group);
        });
      }
      const cards = [...root.querySelectorAll('[data-mjr-guide-card]')];
      const brandGroups = [...root.querySelectorAll('[data-mjr-guide-brand]')];
      const empty = root.querySelector('[data-mjr-guide-empty]');
      let filter = 'all';

      const apply = () => {
        const query = (input?.value || '').trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const matchesFilter = filter === 'all' || card.dataset.guideCategory?.includes(filter);
          const matchesSearch = !query || card.dataset.guideSearch?.includes(query);
          card.hidden = !(matchesFilter && matchesSearch);
          if (!card.hidden) visible += 1;
        });
        brandGroups.forEach((group) => {
          const visibleCards = [...group.querySelectorAll('[data-mjr-guide-card]')].filter((card) => !card.hidden);
          group.hidden = visibleCards.length === 0;
          if (query && visibleCards.length) group.open = true;
        });
        if (empty) empty.hidden = visible > 0;
      };

      input?.addEventListener('input', apply);
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          filter = button.dataset.mjrGuideFilter;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          apply();
        });
      });
    };

    document.querySelectorAll('[data-mjr-guide-directory]').forEach(bindDirectory);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-mjr-guide-directory]').forEach(bindDirectory);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mujeron-size-guide-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindDirectory = (root) => {
      if (!root || root.dataset.mjrGuideDirectoryBound === 'true') return;
      root.dataset.mjrGuideDirectoryBound = 'true';
      const input = root.querySelector('[data-mjr-guide-search]');
      const buttons = [...root.querySelectorAll('[data-mjr-guide-filter]')];
      const grid = root.querySelector('[data-mjr-guide-grid]');
      const originalCards = [...root.querySelectorAll('[data-mjr-guide-card]')];
      const brands = new Map();
      originalCards.forEach((card) => {
        const brand = card.dataset.guideBrand || 'Otras guías';
        if (!brands.has(brand)) brands.set(brand, []);
        brands.get(brand).push(card);
      });
      if (grid && !grid.querySelector('[data-mjr-guide-brand]')) {
        brands.forEach((brandCards, brand) => {
          const group = document.createElement('details');
          group.className = 'mjr-guide-brand';
          group.dataset.mjrGuideBrand = brand.toLowerCase();
          group.innerHTML = `
            <summary><strong>${brand}</strong><span class="mjr-accordion__toggle" aria-hidden="true"></span></summary>
            <div class="mjr-guide-brand__items"></div>
          `;
          const items = group.querySelector('.mjr-guide-brand__items');
          brandCards.forEach((card) => items.appendChild(card));
          grid.appendChild(group);
        });
      }
      const cards = [...root.querySelectorAll('[data-mjr-guide-card]')];
      const brandGroups = [...root.querySelectorAll('[data-mjr-guide-brand]')];
      const empty = root.querySelector('[data-mjr-guide-empty]');
      const requestedFilter = new URLSearchParams(window.location.search).get('category')?.trim().toLowerCase();
      const requestedButton = buttons.find((button) => button.dataset.mjrGuideFilter === requestedFilter);
      let filter = requestedButton?.dataset.mjrGuideFilter || 'all';

      const apply = () => {
        const query = (input?.value || '').trim().toLowerCase();
        let visible = 0;
        cards.forEach((card) => {
          const matchesFilter = filter === 'all' || card.dataset.guideCategory?.includes(filter);
          const matchesSearch = !query || card.dataset.guideSearch?.includes(query);
          card.hidden = !(matchesFilter && matchesSearch);
          if (!card.hidden) visible += 1;
        });
        brandGroups.forEach((group) => {
          const visibleCards = [...group.querySelectorAll('[data-mjr-guide-card]')].filter((card) => !card.hidden);
          group.hidden = visibleCards.length === 0;
          if (!visibleCards.length) group.open = false;
        });
        if (empty) empty.hidden = visible > 0;
      };

      input?.addEventListener('input', apply);
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          filter = button.dataset.mjrGuideFilter;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          apply();
        });
      });
      if (requestedButton) {
        buttons.forEach((button) => {
          const active = button === requestedButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }

      brandGroups.forEach((group) => {
        group.addEventListener('toggle', () => {
          if (!group.open) {
            group.querySelectorAll('[data-mjr-guide-card][open]').forEach((card) => { card.open = false; });
            return;
          }
          brandGroups.forEach((otherGroup) => {
            if (otherGroup !== group) otherGroup.open = false;
          });
        });
      });

      cards.forEach((card) => {
        card.addEventListener('toggle', () => {
          if (!card.open) return;
          cards.forEach((otherCard) => {
            if (otherCard !== card) otherCard.open = false;
          });
        });
      });
      apply();
    };

    document.querySelectorAll('[data-mjr-guide-directory]').forEach(bindDirectory);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-mjr-guide-directory]').forEach(bindDirectory);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
